import {URLParameterType} from '@gongxigames/framework/core/types';

export type ParameterUrlParser<T> = {
    alias?: string | string[];
    typePropertyInURL: URLParameterType;
    parseValue?: (value: any) => T;
    debugOnly?: boolean;
};

export type ParameterSchema<T> = {
    readonly?: boolean;
    defaultValue: T;
    keepInStorage?: boolean;
    urlParser?: ParameterUrlParser<T>;
};

export type SettingsParametersSchema<Parameters> = {
    [K in keyof Parameters]: ParameterSchema<Parameters[K]>
};

export interface ISettings<Parameters = {}> {
    addParametersSchema<ParametersSchema>(schema: SettingsParametersSchema<ParametersSchema>): void;

    has<K extends keyof Parameters>(parameterName: K): boolean;

    set<K extends keyof Parameters>(parameterName: K, value: Parameters[K]): void;

    setIfPossible<K extends keyof Parameters>(parameterName: K, value: Parameters[K]): void;

    get<K extends keyof Parameters>(parameterName: K): Parameters[K];

    setParameters(parameters: Partial<Parameters>): void;

    getAllProperties(): Parameters;
}
